<template>
	<div class="friendshipline">
		<div class="blackcar">

			<div class="dataNav">
			 
				<img class="leftImg" src="../assets/newimg/gy_leftimg@2x.png" alt="" v-if="count == 0" @click="navPrev"/>
				<img class="leftImg" style="transform: rotate(180deg);" v-if="count > 0"
				src="../assets/newimg/gy_rightimg@2x.png" alt=""  @click="navPrev"/>
				
			    <div class="dataNavList" ref="dataNavList">
			        <div class="dataNavListItem" v-for="(item, index) in linkslist" 
					:key="index" :style="{transform:'translateX(-'+move*100+'px)'}"
					@click="toprojectDetails(index,item)" >
						<div class="imgcon">
							<el-image fit='cover' :src="getFileAccessHttpUrl(item.indexPic)" :title="item.title" ></el-image>
						</div>
						<el-image fit='cover' class="fundraisimg" v-if="item.state == 0"
						:src="require('../assets/newimg/fundraisimg@2x.png')" alt="" ></el-image>				
					    <div class="infocon">
							<div class="title" :title="item.title">{{item.title?item.title.substring(0,20):'-'}}</div>
							<div class="mechan">执行机构：{{item.reciveDept?item.reciveDept.substring(0,20):'-'}}</div>
							<div class="time">资助时间：{{item.startDate || '-'}}-{{item.endDate || '-'}}</div>
							<div class="addr">资助地点：{{item.contributionFlow?item.contributionFlow.substring(0,20):'-'}}</div>
						</div>
						<div class="donatebtn" v-if="item.state == 0">我要捐助</div>
						<div class="seebtn" v-if="item.state == 1">查看详情</div>
					</div>
			        <!-- //move变量为每次移动的距离，菜单项向左移的所以移动距离是负值，负号写好了，使move是正值方便计算 -->
			    </div>
		
				<img class="rightImg" src="../assets/newimg/gy_rightimg@2x.png" alt="" v-if="count != 2" @click="navNext"/>				
				<img class="rightImg" style="transform: rotate(180deg);" v-if="count == 2"
				src="../assets/newimg/gy_leftimg@2x.png" alt="" @click="navNext"/>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	export default {

	  data: function() {
			return {
				linkslist:[],
				move:0,
				count:0,
				dataNavListRealWidth:0,
				dataNavListViewWidth:0,
				
			};
	  },
	  
	  mounted() {		

	  },
	  
	  created(){
		 this.getPageList() 
	  },
	  
	  methods: {
		    getPageList() {
		    	  var that = this;
		    	  var obj = {
		    			pageNo: 1,
		    			pageSize: 6,
		    			column:"startDate",
		    			order:"desc",
						state:"0"
		    	  };
		    	  this.httpGet("web/thpDonationActivity/queryPageList", obj).then(res => {
						that.linkslist = res.result.records;
						that.dataNavListViewWidth = (this.linkslist.length-1) * 6.2;
		    	  });
		    	  
		    },
			
			nav(link) {
				  // window.open(link);
			},
			
			//跳转捐赠
			toprojectDetails(indexsign,item){
				this.$router.push({ path: '/projectDetails', query: {index:indexsign,id:item.id} });
			},
		  
		    getLinks(){
				// this.linkslist = ['1','2','3','1','2','3','1','2','3']
				// this.dataNavListViewWidth = (this.linkslist.length-1) * 6.2;
		    },
		  
			// 当菜单项向右的可移动距离大于单个菜单项的宽度时，move减去一个菜单项的宽度（即右移移动一个菜单项的宽度），
				// 当菜单项向右的可移动距离小于单个菜单项的宽度时，move等于0（即回到最开始没有移动的状态）
			navPrev(){
				if(this.move>12.4){
					this.move = this.move-12.4;
					this.count = this.count - 1
				}else{
					this.move = 0
					this.count = 0
				}
			},

		    navNext(){
			    if(this.move<=this.dataNavListViewWidth-12.4){
				   this.move = this.move + 12.4;
				   this.count = this.count + 1
			    }  
		    },
			
		
	  },
	
	  
	};
	
</script>

<style scoped=" scoped" lang="scss">
	*{
		margin:0;padding:0; 
	}
	.friendshipline{
		height: 100px;
		width: 100%;
		.blackcar{
			display:flex;
			justify-content: center;
			padding-top:25px;	
			width: 100%;
			.dataNav {
				 display: flex;
				 height: 453px;
				 width: 100%;
				 .leftImg{
					 cursor: pointer;
					 height: 80px;
					 width:39px;
					 margin-right:30px;
					 margin-top: 180px;	
				 }
				 .rightImg{
					 cursor: pointer;
					 height: 80px;
					 width:39px;
					 margin-left: 30px;
					 margin-top: 180px;
				 }
				 .dataNavList {
					 display: flex;
					 align-items: center;
					 flex-wrap: nowrap;
					 height: 453px;
					// 超出部分隐藏
					 overflow: hidden;
					 width: 1220px;
					 .dataNavListItem{
						 cursor: pointer;
						 list-style:none;
						 border: 1px solid #B5B5B5;
						 cursor: pointer;
						 height: 423px;
						 //每个菜单项的宽度要固定，不然move值无法计算，当然也可以通过其他方法来设置以适应自己的表格
						 font-size: 16px;
						 // 过渡效果
						 transition:transform .2s;
						 margin-right: 40px;
						 width:calc(50% - 20px);
						// width: 590px;
						display: inline-table;
						 .imgcon{
							 width: 580px;
							 height: 220px;
							 display: flex;
							 .el-image{
								width: 100%;
								height: 220px; 
							 }
						 }
						 .fundraisimg{
							 position: absolute;
							 z-index: 5;
							 width: 44px;
							 height: 50px;
							 top: -10px;
							 left: 40px;
						 }
						 .infocon{
							margin-left: 40px;
							font-size: 16px;
							font-weight: 400;
							color: #666666;
							width: 100%;
							.title{
								font-size: 18px;
								color: #333333;
								height: 50px;
								line-height:50px;
							}
							.mechan,.time,.addr{
								height: 35px;
								line-height: 35px;
							}
						 }
						 .donatebtn,.seebtn{
							position: absolute;
							z-index: 5;
							width: 96px;
							height:30px;
							line-height:30px;
							text-align: center;
							border-radius: 15px;
							bottom:50px;
							left: 440px;
							font-size: 16px;
							font-weight: 400;
						 }
						 .donatebtn{
							background: #E41E15;
							color: #FFFFFF;
						 }
						 .seebtn{
							border: 1px solid #E41E15;
							color: #E61F26; 						 					
						 }
						 
					 }
					 
					
				 }
		
				 
		 
			 }

			
		}
		
	}
	
	
</style>
